// extracted by mini-css-extract-plugin
export default {"formLable":"MuiSwitch_formLable__-oi9q"};